/* Alumiva — scripts propios (vanilla, sin librerías). */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    var sinAnimar = reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode);
    if (sinAnimar) { els.forEach(function (el) { el.classList.add('mt-visible'); }); return; }
    io = io || new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  function mostrarMedio(galeria, id) {
    galeria.querySelectorAll('[data-media-id]').forEach(function (item) {
      item.hidden = String(item.getAttribute('data-media-id')) !== String(id);
    });
    galeria.querySelectorAll('[data-mt-miniatura]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-mt-miniatura')) === String(id) ? 'true' : 'false');
    });
  }

  function initGaleria(root) {
    (root || document).querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
      if (galeria.dataset.mtInit) return; galeria.dataset.mtInit = '1';
      galeria.querySelectorAll('[data-mt-miniatura]').forEach(function (b) {
        b.addEventListener('click', function () { mostrarMedio(galeria, b.getAttribute('data-mt-miniatura')); });
      });
      var seccion = galeria.closest('[data-mt-seccion]');
      if (seccion) seccion.addEventListener('mt:variante', function (e) {
        if (e.detail && e.detail.media) mostrarMedio(galeria, e.detail.media);
      });

      /* Deslizar con el dedo (o arrastrar con el ratón) para pasar de foto.
         Sobre la línea del antes/después no se cambia de foto: ahí el dedo mueve la línea. */
      var principal = galeria.querySelector('.mt-galeria__principal');
      var items = galeria.querySelectorAll('[data-media-id]');
      if (!principal || items.length < 2) return;
      var x0 = 0, y0 = 0, activo = false;
      principal.addEventListener('pointerdown', function (e) {
        if (e.target.closest('.mt-comp__rango, .mt-comp__agarre')) { activo = false; return; }
        activo = true; x0 = e.clientX; y0 = e.clientY;
      });
      principal.addEventListener('pointerup', function (e) {
        if (!activo) return; activo = false;
        var dx = e.clientX - x0, dy = e.clientY - y0;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
        var ids = Array.prototype.map.call(items, function (it) { return it.getAttribute('data-media-id'); });
        var actual = 0;
        items.forEach(function (it, i) { if (!it.hidden) actual = i; });
        var sig = (actual + (dx < 0 ? 1 : -1) + ids.length) % ids.length;
        mostrarMedio(galeria, ids[sig]);
      });
      principal.addEventListener('pointercancel', function () { activo = false; });
      principal.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  function initProducto(root) {
    (root || document).querySelectorAll('[data-mt-producto]').forEach(function (el) {
      if (el.dataset.mtInit) return; el.dataset.mtInit = '1';
      var fieldsets = el.querySelectorAll('[data-mt-opcion]');
      if (!fieldsets.length) return;
      var datos = JSON.parse(el.querySelector('[data-mt-variantes]').textContent);
      var idInput = el.querySelector('[data-mt-variante-id]');
      var btn = el.querySelector('[data-mt-add]');
      var precio = el.querySelector('[data-mt-precio]');
      var comparar = el.querySelector('[data-mt-comparar]');

      function actualizar() {
        var sel = Array.prototype.map.call(fieldsets, function (f) {
          var c = f.querySelector('input:checked'); return c ? c.value : null;
        });
        var v = datos.find(function (x) {
          return x.options.every(function (o, i) { return o === sel[i]; });
        });
        fieldsets.forEach(function (f, i) {
          var etiqueta = f.querySelector('[data-mt-valor]');
          if (etiqueta && sel[i]) etiqueta.textContent = sel[i];
        });
        if (!v) { btn.disabled = true; return; }
        idInput.value = v.id;
        precio.textContent = v.price;
        comparar.textContent = v.compare; comparar.hidden = !v.compare;
        var titulo = el.querySelector('[data-mt-titulo]');
        if (titulo) titulo.textContent = v.nombre || titulo.dataset.defecto;
        var desc = document.querySelector('[data-mt-desc]'), defecto = document.querySelector('[data-mt-desc-defecto]');
        if (desc && defecto) desc.innerHTML = v.desc || defecto.innerHTML;
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.dataset.textoAnadir : btn.dataset.textoAgotado;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url);
        el.dispatchEvent(new CustomEvent('mt:variante', { detail: v, bubbles: true }));
      }
      fieldsets.forEach(function (f) { f.addEventListener('change', actualizar); });
    });
  }

  function initContadores(root) {
    var els = (root || document).querySelectorAll('[data-mt-contar]:not([data-mt-hecho])');
    if (!els.length) return;
    var sinAnimar = reduce || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode);
    els.forEach(function (el) {
      el.setAttribute('data-mt-hecho', '1');
      var fin = parseFloat(String(el.getAttribute('data-mt-contar')).replace(',', '.'));
      if (sinAnimar || isNaN(fin)) return;
      var pre = el.getAttribute('data-mt-pre') || '', suf = el.getAttribute('data-mt-suf') || '';
      var decimales = (String(el.getAttribute('data-mt-contar')).split(/[.,]/)[1] || '').length;
      var obs = new IntersectionObserver(function (entradas) {
        if (!entradas[0].isIntersecting) return;
        obs.disconnect();
        var t0 = null, dur = 1800, desde = fin >= 1000 ? Math.floor(fin * 0.97) : 0;
        function paso(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
          el.textContent = pre + (desde + (fin - desde) * e).toFixed(decimales) + suf;
          if (p < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      }, { threshold: 0.4 });
      obs.observe(el);
    });
  }

  function once(el, k) { if (el.dataset[k]) return false; el.dataset[k] = '1'; return true; }

  function initFlips(root) {
    (root || document).querySelectorAll('.mt-flip').forEach(function (c) {
      if (!once(c, 'mtFlip')) return;
      function t() { c.classList.toggle('is-flipped'); }
      c.addEventListener('click', t);
      c.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t(); } });
    });
  }

  function initQuiz(root) {
    (root || document).querySelectorAll('[data-mt-quiz]').forEach(function (q) {
      if (!once(q, 'mtQuiz')) return;
      var pasos = q.querySelectorAll('.mt-quiz__paso');
      var barra = q.querySelector('.mt-quiz__barra span');
      var mensajes = JSON.parse(q.querySelector('[data-mt-quiz-mensajes]').textContent || '[]');
      var total = pasos.length - 1, i = 0, primera = 0;
      function ir(n) {
        i = n;
        pasos.forEach(function (p, k) { p.classList.toggle('is-activo', k === n); });
        if (barra) barra.style.width = (Math.min(n, total) / total * 100) + '%';
      }
      q.querySelectorAll('.mt-quiz__op').forEach(function (b) {
        b.addEventListener('click', function () {
          if (i === 0) primera = parseInt(b.getAttribute('data-i'), 10) || 0;
          if (i + 1 === total) {
            var m = q.querySelector('[data-mt-quiz-mensaje]');
            if (m && mensajes[primera]) m.textContent = mensajes[primera];
          }
          ir(i + 1);
        });
      });
      var r = q.querySelector('.mt-quiz__reiniciar');
      if (r) r.addEventListener('click', function () { ir(0); });
      ir(0);
    });
  }

  function initTabs(root) {
    (root || document).querySelectorAll('[data-mt-tabs]').forEach(function (w) {
      if (!once(w, 'mtTabs')) return;
      var btns = w.querySelectorAll('[role="tab"]');
      btns.forEach(function (b, k) {
        b.addEventListener('click', function () {
          btns.forEach(function (x) {
            var on = x === b;
            x.setAttribute('aria-selected', on ? 'true' : 'false');
            x.tabIndex = on ? 0 : -1;
            var p = document.getElementById(x.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        });
        b.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          var n = btns[(k + d + btns.length) % btns.length]; n.focus(); n.click();
        });
      });
    });
  }

  function initComparador(root) {
    (root || document).querySelectorAll('[data-mt-comp]').forEach(function (c) {
      if (!once(c, 'mtComp')) return;
      var r = c.querySelector('.mt-comp__rango');
      function set() { c.style.setProperty('--pos', r.value + '%'); }
      r.addEventListener('input', set); set();
      /* En la galería la línea solo se mueve agarrándola del botón del centro; el resto de la foto sirve para deslizar */
      if (!c.classList.contains('mt-comp--galeria')) return;
      var agarre = document.createElement('span');
      agarre.className = 'mt-comp__agarre';
      agarre.setAttribute('aria-hidden', 'true');
      c.appendChild(agarre);
      var arrastrando = false;
      function mover(e) {
        var b = c.getBoundingClientRect();
        r.value = Math.max(0, Math.min(100, (e.clientX - b.left) / b.width * 100));
        set();
      }
      agarre.addEventListener('pointerdown', function (e) {
        arrastrando = true; e.preventDefault();
        try { agarre.setPointerCapture(e.pointerId); } catch (err) {}
      });
      agarre.addEventListener('pointermove', function (e) { if (arrastrando) mover(e); });
      function soltar() { arrastrando = false; }
      agarre.addEventListener('pointerup', soltar);
      agarre.addEventListener('pointercancel', soltar);
    });
  }

  function initPacks(root) {
    (root || document).querySelectorAll('[data-mt-packs]').forEach(function (p) {
      if (!once(p, 'mtPacks')) return;
      var form = p.closest('form');
      var qty = form && form.querySelector('input[name="quantity"]');
      if (!qty) return;
      function aplicar() { var c = p.querySelector('input:checked'); if (c) qty.value = c.value; }
      p.addEventListener('change', aplicar);
      aplicar();
    });
  }

  function initStepper(root) {
    (root || document).querySelectorAll('[data-mt-stepper]').forEach(function (s) {
      if (!once(s, 'mtStep')) return;
      var inp = s.querySelector('input');
      s.querySelectorAll('[data-d]').forEach(function (b) {
        b.addEventListener('click', function () {
          inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-d'), 10));
        });
      });
    });
  }

  function initBarraCompra(root) {
    var barra = (root || document).querySelector('[data-mt-barra]');
    var form = document.querySelector('.mt-form');
    if (!barra || !form || !('IntersectionObserver' in window) || !once(barra, 'mtBarra')) return;
    new IntersectionObserver(function (e) {
      /* Visible siempre que los botones de compra NO estén en pantalla (por encima o por debajo) */
      barra.classList.toggle('is-visible', !e[0].isIntersecting);
    }).observe(form);
    var b = barra.querySelector('button');
    if (b) b.addEventListener('click', function () {
      var add = form.querySelector('[data-mt-add]');
      if (add && !add.disabled) add.click(); else form.scrollIntoView({ behavior: 'smooth' });
    });
  }

  /* Ratón lateral: se arrastra con el dedo (o el ratón) y la página le sigue a su ritmo,
     como una barra de desplazamiento. Al hacer scroll normal, el ratón baja y sube solo. */
  var arribaIniciado = false;
  function initArriba() {
    if (arribaIniciado) return; arribaIniciado = true;
    var en = !(document.documentElement.lang && document.documentElement.lang.indexOf('es') === 0);
    var raton = document.createElement('div');
    raton.className = 'mt-arriba';
    raton.setAttribute('role', 'scrollbar');
    raton.setAttribute('aria-orientation', 'vertical');
    raton.setAttribute('aria-label', en ? 'Drag to scroll the page' : 'Arrastra para desplazar la página');
    raton.setAttribute('aria-valuemin', '0');
    raton.setAttribute('aria-valuemax', '100');
    raton.tabIndex = 0;
    raton.innerHTML = '<span class="mt-arriba__rueda" aria-hidden="true"></span>';
    document.body.appendChild(raton);

    function limites() {
      var arriba = window.innerHeight * 0.14;
      var abajo = window.innerHeight * 0.80 - raton.offsetHeight;
      return { arriba: arriba, recorrido: Math.max(1, abajo - arriba), max: Math.max(0, document.documentElement.scrollHeight - window.innerHeight) };
    }
    function colocar(prog) {
      var l = limites();
      raton.style.setProperty('--mt-raton-top', Math.round(l.arriba + prog * l.recorrido) + 'px');
      raton.setAttribute('aria-valuenow', String(Math.round(prog * 100)));
    }

    /* arrastre */
    var arrastrando = false, y0 = 0, prog0 = 0;
    raton.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault();
      try { raton.setPointerCapture(e.pointerId); } catch (err) {}
      var l = limites();
      arrastrando = true; y0 = e.clientY; prog0 = l.max > 0 ? window.scrollY / l.max : 0;
      raton.classList.add('is-arrastrando');
    });
    raton.addEventListener('pointermove', function (e) {
      if (!arrastrando) return;
      e.preventDefault();
      var l = limites();
      var prog = Math.min(1, Math.max(0, prog0 + (e.clientY - y0) / l.recorrido));
      colocar(prog);
      window.scrollTo({ top: prog * l.max, behavior: 'instant' });
    });
    function soltar() { if (!arrastrando) return; arrastrando = false; raton.classList.remove('is-arrastrando'); }
    raton.addEventListener('pointerup', soltar);
    raton.addEventListener('pointercancel', soltar);
    raton.addEventListener('lostpointercapture', soltar);
    raton.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    raton.addEventListener('keydown', function (e) {
      var d = { ArrowDown: 0.25, ArrowUp: -0.25, PageDown: 0.9, PageUp: -0.9 }[e.key];
      if (d) { e.preventDefault(); window.scrollBy({ top: d * window.innerHeight, behavior: reduce ? 'auto' : 'smooth' }); }
    });

    var pend = false;
    function check() {
      pend = false;
      var largo = document.documentElement.scrollHeight > window.innerHeight * 1.6;
      raton.classList.toggle('is-visible', largo);
      if (arrastrando) return;
      var l = limites();
      colocar(l.max > 0 ? Math.min(1, Math.max(0, window.scrollY / l.max)) : 0);
    }
    window.addEventListener('scroll', function () { if (!pend) { pend = true; requestAnimationFrame(check); } }, { passive: true });
    window.addEventListener('resize', check);
    window.addEventListener('load', check);
    check();
  }
  /* quita el zoom guardado de la versión anterior */
  try { localStorage.removeItem('mt-zoom'); } catch (e) {}

  var progresoIniciado = false;
  function initProgreso() {
    initArriba();
    if (progresoIniciado || reduce) return; progresoIniciado = true;
    var p = document.createElement('div'); p.className = 'mt-progreso'; p.setAttribute('aria-hidden', 'true');
    document.body.appendChild(p);
    var pend = false;
    window.addEventListener('scroll', function () {
      if (pend) return; pend = true;
      requestAnimationFrame(function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        p.style.transform = 'scaleX(' + (h > 0 ? window.scrollY / h : 0) + ')';
        document.querySelectorAll('.mt-heroe__media img').forEach(function (img) {
          img.style.transform = 'translateY(' + Math.min(window.scrollY, 600) * 0.12 + 'px) scale(1.06)';
        });
        pend = false;
      });
    }, { passive: true });
  }

  function initTilt(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    (root || document).querySelectorAll('.mt-tilt').forEach(function (el) {
      if (!once(el, 'mtTilt')) return;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        el.style.setProperty('--ry', (x * 8) + 'deg'); el.style.setProperty('--rx', (-y * 8) + 'deg');
      });
      el.addEventListener('mouseleave', function () { el.style.setProperty('--ry', '0deg'); el.style.setProperty('--rx', '0deg'); });
    });
  }

  function initAll(root) {
    initReveal(root); initGaleria(root); initProducto(root); initContadores(root);
    initFlips(root); initQuiz(root); initTabs(root); initComparador(root); initStepper(root); initPacks(root);
    initBarraCompra(root); initTilt(root); initProgreso();
  }

  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
